module.exports = __webpack_public_path__ + "static/media/swap_main_bg.a5fe381e.svg";